function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.803,
    height: 23.227,
    viewBox: "0 0 106.803 23.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1",
    d: "M12.269 5.854h3.587a.431.431 0 0 1 .43.43v14.36a.431.431 0 0 1-.43.43h-3.995l.011-1.583a4.7 4.7 0 0 1-1.522 1.431 4.2 4.2 0 0 1-2.176.548 7.9 7.9 0 0 1-3.182-.641 8.294 8.294 0 0 1-2.6-1.766 8.191 8.191 0 0 1-1.761-2.607A8.064 8.064 0 0 1 0 13.267a7.729 7.729 0 0 1 2.267-5.541 7.958 7.958 0 0 1 2.49-1.689 7.554 7.554 0 0 1 3.036-.609 5.288 5.288 0 0 1 2.519.593 7.224 7.224 0 0 1 1.956 1.507zm-4.2 11.582A3.422 3.422 0 0 0 9.94 16.9a3.831 3.831 0 0 0 1.324-1.439 4.374 4.374 0 0 0 0-4.012 3.848 3.848 0 0 0-1.324-1.426 3.433 3.433 0 0 0-1.873-.532 3.528 3.528 0 0 0-1.9.532 3.891 3.891 0 0 0-1.357 1.439 4.061 4.061 0 0 0-.5 2 4.018 4.018 0 0 0 .51 2A3.966 3.966 0 0 0 6.18 16.9a3.493 3.493 0 0 0 1.887.532",
    transform: "translate(0 1.756)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2",
    d: "M13.938 22.4V.431A.43.43 0 0 1 14.367 0h3.341a.43.43 0 0 1 .43.431V22.4a.429.429 0 0 1-.43.43h-3.341a.429.429 0 0 1-.429-.43",
    transform: "translate(4.509)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 3",
    d: "M19.182 22.4V.431a.431.431 0 0 1 .43-.431h3.341a.43.43 0 0 1 .43.431V22.4a.429.429 0 0 1-.43.43h-3.341a.43.43 0 0 1-.43-.43",
    transform: "translate(6.206)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 4",
    d: "M29.256 22.029V1.58a.43.43 0 0 1 .43-.43h7.424a5.819 5.819 0 0 1 3.158.883 6.574 6.574 0 0 1 2.245 2.352 6.413 6.413 0 0 1 .838 3.235 6.383 6.383 0 0 1-.852 3.264 6.533 6.533 0 0 1-2.276 2.337 5.873 5.873 0 0 1-3.112.867h-3.224a.431.431 0 0 0-.43.431v7.51a.43.43 0 0 1-.43.43h-3.341a.429.429 0 0 1-.43-.43m4.2-12.572a.43.43 0 0 0 .43.43h2.75a2.4 2.4 0 0 0 1.264-.342 2.608 2.608 0 0 0 .905-.93 2.61 2.61 0 0 0 0-2.586 2.671 2.671 0 0 0-.905-.937 2.361 2.361 0 0 0-1.264-.349h-2.75a.43.43 0 0 0-.43.43z",
    transform: "translate(9.465 .372)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5",
    d: "M41.227 22.4V.431a.431.431 0 0 1 .43-.431H45a.43.43 0 0 1 .43.431V22.4a.429.429 0 0 1-.43.43h-3.343a.43.43 0 0 1-.43-.43",
    transform: "translate(13.338)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 6",
    d: "M57.848 5.854h3.582a.43.43 0 0 1 .43.43v14.36a.43.43 0 0 1-.43.43h-3.988v-1.583a4.7 4.7 0 0 1-1.522 1.431 4.2 4.2 0 0 1-2.176.548 7.9 7.9 0 0 1-3.182-.641 8.294 8.294 0 0 1-2.6-1.766 8.191 8.191 0 0 1-1.758-2.609 8.064 8.064 0 0 1-.631-3.188 7.729 7.729 0 0 1 2.267-5.542 7.958 7.958 0 0 1 2.49-1.689 7.555 7.555 0 0 1 3.036-.609 5.288 5.288 0 0 1 2.519.593 7.224 7.224 0 0 1 1.956 1.507zm-4.207 11.582a3.422 3.422 0 0 0 1.873-.532 3.832 3.832 0 0 0 1.324-1.439 4.374 4.374 0 0 0 0-4.012 3.848 3.848 0 0 0-1.324-1.431 3.433 3.433 0 0 0-1.873-.532 3.528 3.528 0 0 0-1.9.532 3.891 3.891 0 0 0-1.355 1.439 4.061 4.061 0 0 0-.5 2 4.018 4.018 0 0 0 .51 2 3.966 3.966 0 0 0 1.358 1.439 3.493 3.493 0 0 0 1.887.532",
    transform: "translate(14.744 1.756)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7",
    d: "m68.493 16.265 3.314 1.791a.442.442 0 0 1 .136.662 8.02 8.02 0 0 1-2.31 1.885 7.313 7.313 0 0 1-7.283-.213 8.071 8.071 0 0 1-3.781-6.925A8.194 8.194 0 0 1 60.8 7.779a7.594 7.594 0 0 1 2.427-1.727 7.311 7.311 0 0 1 6.407.244 7.843 7.843 0 0 1 2.316 1.915.44.44 0 0 1-.138.658l-3.319 1.795a3.3 3.3 0 0 0-1.075-.769 3.03 3.03 0 0 0-1.239-.267 2.99 2.99 0 0 0-1.743.533 3.773 3.773 0 0 0-1.218 1.408 4.078 4.078 0 0 0-.449 1.9 3.941 3.941 0 0 0 .457 1.871 3.854 3.854 0 0 0 1.224 1.4 3.029 3.029 0 0 0 2.976.26 3.9 3.9 0 0 0 1.067-.731",
    transform: "translate(18.949 1.756)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8",
    d: "M76.805 21.47a7.086 7.086 0 0 1-3.828-1.08 7.988 7.988 0 0 1-2.756-2.908 8.093 8.093 0 0 1-1.021-4.033 8.209 8.209 0 0 1 2.23-5.67 7.6 7.6 0 0 1 2.427-1.726 7.369 7.369 0 0 1 6.263.152 7.623 7.623 0 0 1 2.541 2.114 8.344 8.344 0 0 1 1.492 3.03 8.164 8.164 0 0 1 .2 3.133.447.447 0 0 1-.439.384H73.731a3.635 3.635 0 0 0 .617 1.21 3.106 3.106 0 0 0 1.035.86 3.181 3.181 0 0 0 1.423.335 2.8 2.8 0 0 0 1.461-.365 3.593 3.593 0 0 0 .977-.813.425.425 0 0 1 .421-.148l3.493.806a.439.439 0 0 1 .294.626 8.077 8.077 0 0 1-2.52 2.809 7.039 7.039 0 0 1-4.125 1.286m-3.228-9.712h6.469a3.76 3.76 0 0 0-.67-1.37 3.492 3.492 0 0 0-1.136-.96 3.1 3.1 0 0 0-2.86 0 3.432 3.432 0 0 0-1.126.952 3.912 3.912 0 0 0-.678 1.378",
    transform: "translate(22.386 1.756)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be921c70949ba5abe2e68daa15482d4f.svg";
export { ForwardRef as ReactComponent };